import _ from 'lodash'
import React, {useCallback,} from 'react'
import {getResponseItem, LoadingWrapper} from '../../Shared'
import {bindQueryParam, mapPathParam} from '../functions/routerHelper'
import {church_getById_Api} from "../../../apis";
import useAsync from "../../../modules/asyncCache/useAsync";
import {PermissionEntity} from "../Permissions/PermissionEntity";
import ChurchEntity from "../Church/ChurchEntity";
import {getId} from "../../../apis/model/base";
import {addFavorite} from "../../../helpers/localStorage";

const ParishContext = React.createContext({})


export const ParishProvider = ({
                                   item,
                                   children,
                                   ...props
                               }) => {

    const apiInfo = church_getById_Api

    const id = getId(item) || item

    const cacheId = mapPathParam(apiInfo.path, {id})

    const {response, isLoading = false} = useAsync({
        apiInfo,
        query: bindQueryParam({id}),
    })

    const isSucceed = Number(_.get(response, 'status')) === 200

    const cache = getResponseItem(response)

    const error = getResponseItem(response, 'error')

    const errorMessage = _.get(response, 'errorMessages.error')

    const error_code = _.get(response, 'errorMessages.error_code')

    const status = {
        title: getResponseItem(response, 'status'),
        description: errorMessage,
    }


    const renderHeader = useCallback((action, isModal) => null, [])

    return (
        <LoadingWrapper isLoading={!item}>
            <ChurchEntity
                key={cacheId}
                item={id}>
                {(item) => {

                    if (item) {
                        addFavorite("churches", _.pick(item, ['_type', 'id', 'idname', 'name', 'photo']))
                    }
                    return (
                        <PermissionEntity item={item}>
                            <ParishContext.Provider
                                value={{
                                    id,
                                    isLoading,
                                    item,
                                    error,
                                    cache,
                                    status,
                                    isSucceed,
                                    error_code,
                                    renderHeader,
                                    errorMessage,
                                    ...props,
                                }}>
                                {children}
                            </ParishContext.Provider>
                        </PermissionEntity>
                    )
                }}
            </ChurchEntity>
        </LoadingWrapper>
    )
}

export default ParishContext
